<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{"SAVE_VIEW" | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeViewModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body formModal">
    <form [formGroup]="viewForm">
      <div class="modalViewGroupDate" *ngIf="!isDynamicView">
        <h4>{{'DATE_START'|translate}} : {{getFormatedDateForModalView(dateStart.value)}}</h4>
        <mat-form-field>
          <input matInput [placeholder]="'HOUR' | translate" formControlName="startHours" type="number">
        </mat-form-field>

        <mat-form-field>
          <input matInput [placeholder]="'MINUTES' | translate" formControlName="startMinutes" type="number">
        </mat-form-field>

        <mat-form-field>
          <input matInput [placeholder]="'SECONDS' | translate" formControlName="startSeconds" type="number">
        </mat-form-field>

        <mat-form-field>
          <input matInput [placeholder]="'MSECONDS' | translate" formControlName="startMilliSeconds"
                 type="number">
        </mat-form-field>
      </div>
      <div class="modalViewGroupDate" *ngIf="!isDynamicView">
        <h4>{{'DATE_END'|translate}} : {{getFormatedDateForModalView(dateEnd.value)}}</h4>
        <mat-form-field>
          <input matInput [placeholder]="'HOUR' | translate" formControlName="endHours" type="number">
        </mat-form-field>

        <mat-form-field>
          <input matInput [placeholder]="'MINUTES' | translate" formControlName="endMinutes" type="number">
        </mat-form-field>

        <mat-form-field>
          <input matInput [placeholder]="'SECONDS' | translate" formControlName="endSeconds" type="number">
        </mat-form-field>

        <mat-form-field>
          <input matInput [placeholder]="'MSECONDS' | translate" formControlName="endMilliSeconds"
                 type="number">
        </mat-form-field>

      </div>
      <mat-form-field>
        <input matInput [placeholder]="'NAME' | translate" formControlName="name" required>
        <mat-error *ngIf="viewForm.get('name').invalid">{{'VALUE_USER_NAME_BETWEEN_2_30'| translate}}</mat-error>
      </mat-form-field>

      <mat-form-field style="width:500px;">
        <textarea matInput [placeholder]="'DESCRIPTION' | translate" formControlName="description"></textarea>
      </mat-form-field>

      <mat-slide-toggle formControlName="featured">{{viewForm.value.featured ? ('FEATURED' | translate) :
        ('NORMAL' | translate)}}
      </mat-slide-toggle>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="closeViewModal()"
            [innerHTML]="'CLOSE' | translate">
    </button>
    <button [disabled]="!viewForm.valid" type="button" class="btn btn-info" (click)="saveView()"
            [innerHTML]="'CREATE_VIEW' | translate">
    </button>
    <button [disabled]="!viewForm.valid" *ngIf="viewId" type="button" class="btn btn-warning"
            (click)="saveView(false)"
            [innerHTML]="'SAVE_CURRENT_VIEW' | translate">
    </button>
  </div>
</ng-template>

<div class="filter-for-list" id="chartFilter">

  <div style="border-bottom:1px solid #ccc;margin-bottom:5px;margin-right:20px;">
    <b style="float:left; margin-right: 5px;" *ngIf="project.name">{{project.name}}
      : {{project.start_date | date:'mediumDate': 'UTC'}}
      -
      {{project.end_date |
        date:'mediumDate': 'UTC'}}  </b>&nbsp;
    <button type="button" (click)="changeIndex(false)" placement="left"
            [disabled]="buttonDisableForLocalStorageViews(0) || showSpinner"
            class="btn local-service-button list-tools" style="background: green; float: left;"
            [ngbTooltip]="'LOCAL_STORAGE_BACK' | translate">
      <fa-icon [icon]="faUndoAlt"></fa-icon>
    </button>
    <button type="button" (click)="changeIndex(true)" placement="left"
            [disabled]="buttonDisableForLocalStorageViews(1) || showSpinner"
            class="btn local-service-button list-tools" style="background: green; float: left;"
            [ngbTooltip]="'LOCAL_STORAGE_FRONT' | translate">
      <fa-icon [icon]="faRedoAlt"></fa-icon>
    </button>
    <b style="float:left;color:#f44336" *ngIf="!viewId && viewName" [ngbTooltip]="viewDescription" placement="right">
      {{viewName}}
    </b>
    <b style="float:left;color:#f44336" *ngIf="viewId && viewNameToDisplay" [ngbTooltip]="viewDescription"
       placement="right">
      &nbsp;&nbsp;{{viewNameToDisplay}}
      <fa-icon *ngIf="viewFeatured" [icon]="faStar" style="color:orange"></fa-icon>
    </b>

    <app-project-sub-menu [topLocation]="false" [forGraphicComponent]="true"></app-project-sub-menu>

    <button type="button" class="btn list-tools" style="background: #f44336"
            (click)="openGraphicalViewListModal()" placement="left"
            [ngbTooltip]="'TOOL_MENU_VIEWS' | translate">
      <fa-icon [icon]="faList"></fa-icon>
    </button>

    <button type="button" class="btn list-tools" style="background: darkorchid"
            (click)="openViewModal(content)" placement="left"
            [ngbTooltip]="'SAVE_VIEW' | translate"
            *ngIf="authenticationService.userHasRoleOsmos()">
      <fa-icon [icon]="faSave"></fa-icon>
    </button>

    <button type="button" class="btn list-tools" style="background: orange"
            (click)="downloadChartImage()" placement="left"
            [ngbTooltip]="'EXPORT_IMAGE' | translate">
      <fa-icon [icon]="faImage"></fa-icon>
    </button>

    <button type="button" class="btn list-tools" style="background: darkgreen"
            (click)="showExportCsvModal()" placement="left"
            [ngbTooltip]="'EXPORT CSV' | translate">
      <fa-icon [icon]="faFileExcel"></fa-icon>
    </button>

    <!--    <button type="button" class="btn list-tools" style="background: cornflowerblue"-->
    <!--            (click)="fullScreen()" placement="left"-->
    <!--            [ngbTooltip]="'FULLSCREEN' | translate">-->
    <!--      <fa-icon [icon]="faExpandArrowsAlt"></fa-icon>-->
    <!--    </button>-->

    <button type="button" class="btn list-tools btn-eraser"
            (click)="showDataProcessingMeasureModal(1)" placement="left"
            [ngbTooltip]="'ERASE' | translate"
            *ngIf="authenticationService.userHasRoleOsmos()">
      <fa-icon [icon]="faEraser"></fa-icon>
    </button>

    <button type="button" class="btn list-tools btn-offset"
            (click)="showDataProcessingMeasureModal(0)" placement="left"
            [ngbTooltip]="'OFFSET' | translate"
            *ngIf="authenticationService.userHasRoleOsmos()">
      <fa-icon [icon]="faFileSignature"></fa-icon>
    </button>

    <button type="button" class="btn list-tools btn-threshold"
            (click)="showDataProcessingMeasureModal(2)" placement="left"
            [ngbTooltip]="'SEUILS' | translate"
            *ngIf="authenticationService.userHasRoleOsmos()">
      ~
    </button>

    <button *ngIf="thermalCorrectionAvailable" type="button" class="btn list-tools"
            [routerLink]="'/chart/'+urlParameter" routerLinkActive="active">
      {{"RAW_DATA" | translate}}
    </button>

    <button *ngIf="thermalCorrectionAvailable" type="button" class="btn list-tools"
            [routerLink]="'/ctherm/'+urlParameter" routerLinkActive="active">
      {{"THERMALLY_COMPENSATED_DATA"|translate}}
    </button>

    <br clear="both "/>
  </div>

  <div>
    <mat-form-field class="date-picker" placement="bottom"
                    [ngbTooltip]="'START_DATE_TOOLTIP' | translate">
      <input matInput [formControl]="dateStart" [matDatepicker]="picker1" required
             [placeholder]="'FROM' | translate" (dateChange)="setDatePickerStartTime()">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1 [startAt]="dateStart"></mat-datepicker>
    </mat-form-field>
    <button type="button" class="btn btnClock" style="background: teal;"
            (click)="showTimerModal()" placement="right"
            [ngbTooltip]="'TIMER_MODAL' | translate">
      <fa-icon [icon]="faTimerClock"></fa-icon>
    </button>
    <div class="starttime">{{dateStart.value | date:'HH:mm:ss':'UTC'}}
    </div>
  </div>


  <div style="margin-top:-72px;">
    <mat-form-field class="date-picker" style="margin-left:58px" placement="bottom"
                    [ngbTooltip]="'END_DATE_TOOLTIP' | translate">
      <input matInput [formControl]="dateEnd" [matDatepicker]="picker2" required
             (dateChange)="setDatePickerEndTime()"
             [placeholder]="'TO' | translate">
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2 [startAt]="dateEnd"></mat-datepicker>
    </mat-form-field>
    <div class="endtime" [innerText]="dateEnd.value | date:'HH:mm:ss':'UTC'"></div>
  </div>

  <div class="date-picker-button">

    <button type="button" class="btn btn-datepicker" style="background: green"
            (click)="setStaticChart()" placement="right"
            [ngbTooltip]="'TOOL_RELOAD_DATA' | translate">
      <fa-icon [icon]="faCheck"></fa-icon>
    </button>
    <button type="button" class="btn btn-datepicker" style="background: deepskyblue"
            (click)="resetChart()" placement="right"
            [ngbTooltip]="'CHART_RESET_ZOOM' | translate">
      <fa-icon [icon]="faSync"></fa-icon>
    </button>
  </div>
  <div class="block-separator"></div>
  <div class="extras-features" style="width:120px">
    <mat-form-field class="stats-features" style="margin-left:10px;" placement="left"
                    [ngbTooltip]="'UTC_OFFSET_MEASURES_TOOLTIP' | translate">
      <mat-select [(value)]="timeZone" [placeholder]="'UTC_OFFSET_MEASURES' | translate"
                  (selectionChange)="setTimeZone($event)">
        <mat-option *ngFor="let offset of offsetsForUTC()" [value]="offset">UTC {{offset > 0 ? "+" + offset : offset}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="block-separator"></div>
  <mat-radio-group [(ngModel)]="underSampling" class="under-sampling" placement="bottom"
                   (change)="changeUndersampling($event)"
                   [ngbTooltip]="'UNDERSAMPLING_TOOLTIP' | translate">
    <mat-radio-button [value]="5000000">{{"RAW_DATA"|translate}}</mat-radio-button>
    <mat-radio-button [value]="1000">{{"FAST" |translate}} - 1000</mat-radio-button>
  </mat-radio-group>
  <div class="block-separator"></div>
  <div class="extras-features">

    <mat-slide-toggle [ngModel]="showEvents" (change)="setStaticChartAndEvent()" placement="left"
                      [ngbTooltip]="'CHART_LEGEND_DYNAMICS' | translate">{{'CHART_LEGEND_DYNAMICS'|translate}}
    </mat-slide-toggle>
    <mat-slide-toggle [ngModel]="multiDynamic" (change)="setMultiDynamic()" placement="left"
                      [ngbTooltip]="'MULTI_DYNAMICS_V52' | translate">{{'MULTI_DYNAMICS_V52'|translate}}
    </mat-slide-toggle>

    <mat-slide-toggle [ngModel]="showAmplitude" (change)="setAmplitude()" placement="left"
                      [ngbTooltip]="'CHART_LEGEND_AMPLITUDE' | translate">{{'CHART_LEGEND_AMPLITUDE'|translate}}
    </mat-slide-toggle>

    <br clear="left"/>
    <mat-slide-toggle *ngIf="isDynamicView === false" [ngModel]="showAxisManager" (change)="setLocationView()"
                      placement="left"
                      [ngbTooltip]="'AXIS_VIEW_TOOLTIP' | translate">{{'AXIS_VIEW'|translate}}
    </mat-slide-toggle>
    <mat-slide-toggle [ngModel]="showOffset"
                      (change)="setStaticChartAndOffset()"
                      [ngbTooltip]="'OFFSET' | translate">Offset
    </mat-slide-toggle>

    <button mat-stroked-button class="btn btn-warning smallButton" *ngIf="isDynamicView" (click)="setStaticChart()"
            placement="left"
            [ngbTooltip]="'BACK_BUTTON' | translate">{{'BACK_BUTTON' | translate}}
    </button>

    <app-smart-offsets-mode *ngIf="authenticationService.userHasRoleOsmos()"></app-smart-offsets-mode>
    <mat-slide-toggle [checked]="thresholdActivated" [disabled]="!thresholdTable || thresholdTable.length === 0"
                      (change)="setThresholdChange()">{{"THRESHOLDS" | translate}}</mat-slide-toggle>
    <mat-slide-toggle [checked]="forceDynamic"
                      (change)="setForceDynamic()">{{'FORCE_DYN' | translate}}</mat-slide-toggle>
    <mat-slide-toggle [checked]="showDynFlagValue"
                      (change)="setShowFlagValue()">{{'SHOW_DYN_FLAG_VALUE' | translate}}</mat-slide-toggle>


  </div>
  <div class="block-separator"></div>


  <mat-radio-group [(ngModel)]="chartType" class="chart-type" (change)="setStaticChart()">
    <mat-radio-button [value]="'line'" placement="left"
                      [ngbTooltip]="'LINE_TOOLTIP' | translate">
      <fa-icon class="chart-icon" [icon]="faChartLine"></fa-icon>
    </mat-radio-button>
    <mat-radio-button [value]="'area'" placement="left"
                      [ngbTooltip]="'AREA_TOOLTIP' | translate">
      <fa-icon class="chart-icon" [icon]="faChartArea"></fa-icon>
    </mat-radio-button>
    <mat-radio-button [value]="'column'" placement="left"
                      [ngbTooltip]="'COLUMN_TOOLTIP' | translate">
      <fa-icon class="chart-icon" [icon]="faChartBar"></fa-icon>
    </mat-radio-button>
    <mat-radio-button [value]="'spline'" placement="left"
                      [ngbTooltip]="'SPLINE_TOOLTIP' | translate">S-
      <fa-icon class="chart-icon" [icon]="faChartLine"></fa-icon>
    </mat-radio-button>
    <mat-radio-button [value]="'areaspline'" placement="left"
                      [ngbTooltip]="'AREA_SPLINE_TOOLTIP' | translate">S-
      <fa-icon class="chart-icon" [icon]="faChartArea"></fa-icon>
    </mat-radio-button>
    <mat-slide-toggle [ngModel]="stepInChart" (change)="setStepped()" placement="left"
                      [ngbTooltip]="'STEPPED_CURVE_TOOLTIP' | translate">
      <fa-icon class="chart-icon" [icon]="faCubes" style="margin-left: 4px;"></fa-icon>
    </mat-slide-toggle>
  </mat-radio-group>

  <div class="extras-features" style="width:140px">
    <mat-form-field class="stats-features" style="width:45%" placement="left"
                    [ngbTooltip]="'GROUP_BY_TOOLTIP' | translate">
      <mat-select [(value)]="frequencyForDataGrouping" [placeholder]="'GROUP_BY' | translate"
                  (selectionChange)="periodSelectedForDataGrouping !== 'none' ? setStaticChart() : null">
        <mat-option *ngFor="let freq of getFrequencyForDataGrouping()"
                    [value]="freq">{{freq}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="stats-features" style="margin-left:10px;width:45%" placement="left"
                    [ngbTooltip]="'GROUP_PERIOD_TOOLTIP' | translate">
      <mat-select [(value)]="periodSelectedForDataGrouping" [placeholder]="'PERIOD' | translate"
                  (selectionChange)="setPeriodSelectedForDataGrouping($event)">

        <mat-option *ngFor="let period of periodsForDataGrouping" [value]="period">{{period}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>


  <mat-button-toggle-group class="sms-or-measures" *ngIf="isDynamicView === false" placement="left"
                           appearance="standard"
                           [(value)]="showSms" (change)="setStaticChartAndSms($event)"
                           style="float: right; margin-top: -21px; margin-bottom: 6px;">
    <mat-button-toggle [value]="0">{{'ALL' | translate}}</mat-button-toggle>
    <mat-button-toggle [value]="1">{{'SMS' | translate}}</mat-button-toggle>
    <mat-button-toggle [value]="2">{{'MEASURE' | translate}}</mat-button-toggle>
  </mat-button-toggle-group>

  <br clear="both"/>
</div>

<app-progressbar *ngIf="showSpinner"></app-progressbar>
<div #chartTarget id="chartTarget"></div>

<app-location-tree [height]="locationTreeHeight"></app-location-tree>

<div class="locationTreeTarget" [ngStyle]="{'display' : showAxisManager ? 'block' : 'none'}" id="axisTarget">
  <div class="header-right-tools">
    <mat-slide-toggle style="float:right;margin-right:14px;margin-top:5px;" [ngModel]="opposite"
                      (change)="invertAxis()" placement="left"
                      [ngbTooltip]="'INVERT_AXIS' | translate">{{'INVERT_AXIS'|translate}}
    </mat-slide-toggle>

  </div>
  <div *ngFor="let axis of unitCollection"
       class="axis-manager">
    <h4>{{axis.unit | translate}}


      <mat-radio-group style="float:right;margin-top:2px" [name]="axis.unit"
                       (change)="onChangeSetAxisSide($event)"
                       [ngModel]="axis.side" placement="left"
                       [ngbTooltip]="'CHANGE_AXIS_SIDE_TOOLTIP' | translate">
        <mat-radio-button value="left" style="margin-left:5px">{{"L"|translate}}</mat-radio-button>
        <mat-radio-button value="right" style="margin-left:5px">{{"R"|translate}}</mat-radio-button>
      </mat-radio-group>
      <b style="float:right;margin:1px 5px;color:#ccc"> | </b>
      <mat-slide-toggle style="float:right" [(ngModel)]="axis.visible"
                        (change)="setAxisVisibility(axis.unit,axis.visible)"
                        placement="left"
                        [ngbTooltip]="'SHOW_AXIS_TOOLTIP' | translate">
        {{ (axis.visible ? "VISIBLE" : "HIDDEN")|translate }}
      </mat-slide-toggle>
    </h4>
    <div style="width:60%;float:left">
      <mat-form-field style="width:40%;margin-left:10%;" placement="left"
                      [ngbTooltip]="'MIN_AXIS_TOOLTIP' | translate">
        <input matInput placeholder="min" [(ngModel)]="axis.min" type="number">
      </mat-form-field>
      <mat-form-field style="width:40%" placement="left"
                      [ngbTooltip]="'MAX_AXIS_TOOLTIP' | translate">
        <input matInput placeholder="max" [(ngModel)]="axis.max" type="number">
      </mat-form-field>
    </div>
    <div style="width:40%;float:left;margin-top:10px">
      <button mat-stroked-button class="btn btn-primary smallButton"
              (click)="setAxisMinAndMax(axis.unit,axis.max,axis.min)" placement="left"
              [ngbTooltip]="'LIMIT_AXIS_TOOLTIP' | translate">{{"LIMIT" | translate }}
      </button>
      <button mat-stroked-button class="btn btn-primary smallButton"
              (click)="setAxisMinAndMax(axis.unit,null,null)" placement="left"
              [ngbTooltip]="'CLEAR_LIMIT_AXIS_TOOLTIP' | translate">{{"CLEAR" | translate }}
      </button>
    </div>

  </div>
  <br clear="both"/>
</div>
